import { Badge, Card, CardBody, Col, Container, Row, Spinner } from 'react-bootstrap';
import clsx from 'clsx';
import { useServicesPage } from '@/hooks/useServicesPage';

const WhyChooseUs = ({ sectionData: propSectionData }) => {
  const { section: fetchedSection, loading, error } = useServicesPage('how_we_work');
  const section = propSectionData || fetchedSection;

  const bgColor = section?.background_color || 'light';
  const bgEffect = section?.background_effect || null;
  let bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : 'bg-light';
  // Apply gradient effect if selected
  if (bgColor === 'primary' && bgEffect === 'gradient') {
    bgClass = 'section-bg-primary-gradient';
  }

  if (loading && !propSectionData) {
    return (
      <section className={`py-5 py-lg-6 ${bgClass} services-section why-choose-us-section`}>
        <Container>
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        </Container>
      </section>
    );
  }

  if (error || !section || !section.is_active) {
    return null;
  }

  const items = section.items || [];
  const hasDotsEffect = bgColor === 'primary' && bgEffect === 'dots';

  return (
    <section className={`py-5 py-lg-6 ${bgClass} services-section why-choose-us-section ${hasDotsEffect ? 'position-relative overflow-hidden' : ''}`} id="how-we-work">
      {hasDotsEffect && (
        <>
          <span className="section-bg-dots section-bg-dots--left d-none d-xl-block" />
          <span className="section-bg-dots section-bg-dots--right d-none d-lg-block" />
        </>
      )}
      <Container className={hasDotsEffect ? 'position-relative' : ''}>
        {/* Header Section */}
        <Row className="mb-4">
          <Col>
            {section.subtitle && (
              <Badge bg="primary" className="bg-opacity-10 text-primary mb-3">
                {section.subtitle}
              </Badge>
            )}
            {section.title && (
              <h2 className="sec-title mb-3">
                {section.title}
              </h2>
            )}
            {section.intro_text && (
              <p className="lead intro-text mb-0" dangerouslySetInnerHTML={{ __html: section.intro_text }} />
            )}
          </Col>
        </Row>

        {/* Process Steps */}
        <Row className="g-4">
          {items.map((item) => {
            const Icon = item.IconComponent;
            const colorMap = {
              'primary': 'primary',
              'success': 'success',
              'info': 'info',
              'warning': 'warning',
              'danger': 'danger'
            };
            const bgColor = colorMap[item.icon_color] || 'primary';
            const variant = `bg-${bgColor} text-${bgColor}`;
            
            return (
              <Col key={item.id} md={6} xl={3}>
                <Card className="h-100 border-0 shadow-sm how-we-work-card">
                  <CardBody className="p-4 p-lg-5">
                    {Icon && (
                      <div className={clsx(variant, 'icon-lg bg-opacity-10 rounded-circle mb-4 flex-centered')}>
                        <Icon size={24} />
                      </div>
                    )}
                    {item.title && (
                      <h5 className="mb-3 fw-bold" style={{ color: '#000000' }}>
                        {item.title}
                      </h5>
                    )}
                    {item.description && (
                      <p className="mb-0 intro-text" style={{ color: '#495057' }} dangerouslySetInnerHTML={{ __html: item.description }} />
                    )}
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseUs;

